import React from "react";
import moment from "moment";
import l10n from "../../../../../../localization";
import Helpers from "../../../../../../helpers/helpers";

export default ({ meterSiteCode, meterCode, meters }) => {
  const filteredBySiteCode = meters.meterReadingsByDay.result.filter(
    (meterReadingByDay) => meterReadingByDay.meterSiteCode === meterSiteCode
  );

  let readings = [];

  if (filteredBySiteCode.length > 0) {
    const showingMeter = filteredBySiteCode[0].meters.filter(
      (fMeterSideCode) => fMeterSideCode.meterCode === meterCode
    );

    if (showingMeter.length > 0) {
      if (showingMeter[0].readings && showingMeter[0].readings.length > 0) {
        readings = [...showingMeter[0].readings];
      }
    }
  }

  if (readings.length <= 0) return null;

  return readings.map((meterReading, index) => (
    <tr key={`${meterCode}_${index}`}>
      <td>{moment(meterReading.date).format("DD.MM.YYYY")}</td>
      <td>{meterReading.meterCode}</td>
      <td>{meterReading.reading}</td>
      <td>{Helpers.formatNumber(meterReading.consumption)}</td>
      <td>{Helpers.formatNumber(meterReading.deductedConsumption)}</td>
      <td>{Helpers.formatNumber(meterReading.addedConsumption)}</td>
      <td>{Helpers.formatNumber(meterReading.accountedConsumption)}</td>
      <td>
        {meterReading.isIncrConsumption && l10n.meterRow.increasedConsumption}
        {meterReading.isIncrConsumptionMainMeter &&
          " ; "}
        {meterReading.isIncrConsumptionMainMeter &&
          l10n.meterRow.increasedConsumptionMain}
      </td>
    </tr>
  ));
};
